<script setup>
import { ref, computed } from 'vue'
// import HeaderMenu from '../components/HeaderMenu.vue'
import ToggleThemeButton from '../buttons/ToggleThemeButton.vue'
import BubttonInstallPWA from '../buttons/BubttonInstallPWA.vue'

import AppHeader from '../content/AppHeader.vue'
import AppStatisticSlider from '../content/AppStatisticSlider.vue'
import ImgsSliderMain from '../content/ImgsSliderMain.vue'
import BlockAboutMain from '../content/BlockAboutMain.vue'
import BlockTimeMain from '../content/BlockTimeMain.vue'
import BlockAboutFullMain from '../content/BlockAboutFullMain.vue'
import BlockInfoBorderArround from '@/content/BlockInfoBorderArround.vue'
import BlockDevicesBorderArround from '@/content/BlockDevicesBorderArround.vue'
import BlockAppRatings from '../content/BlockAppRatings.vue'
import CommentsDrawer from '../content/CommentsDrawer.vue'

import { useThemeStore } from '@/stores/themeStore';
import VideoHeader from '../content/VideoHeader.vue'

const themeStore = useThemeStore();
themeStore.initTheme()

const aboutArroundDataArray = computed(() => {
   const array = window.messagesDict.ru.about_arround
   try {
      if (Array.isArray(array)) {
         return array
      } else {
         return JSON.parse(array) || []
      }
   } catch (error) {
      return []
   }
})

// кодек H.264, MP4
const trailerUrl = ref(null)
const isVideoHeaderShow = ref(true)

if ('trailerUrl' in window.messagesDict.ru.header) {
   trailerUrl.value = window.messagesDict.ru.header.trailerUrl
} else {
   isVideoHeaderShow.value = false
}

const headerTextColor = computed(() => {
   if (isVideoHeaderShow.value)
      return '#e8eaed'
   else
      return null
})

const headerSecondaryTextColor = computed(() => {
   if (isVideoHeaderShow.value)
      return '#9aa0a6'
   else
      return null
})

</script>

<template>
   <ToggleThemeButton style="color: #48937a;" />

   <div class="common_content">

      <div :class="isVideoHeaderShow ? 'bg_gray' : ''">

         <VideoHeader :item="trailerUrl" v-if="isVideoHeaderShow" />

         <div :class="'block__item RTL-end'" v-if="!isVideoHeaderShow">
         </div>

         <AppHeader :firstColor="headerTextColor" :secondaryColor="headerSecondaryTextColor" :title="$t('header.title')"
            :description="$t('header.description')" :text_additional="$t('header.text_additional')" />

         <AppStatisticSlider :firstColor="headerTextColor" :secondaryColor="headerSecondaryTextColor"
            :sub_header="$t('sub_header.imgUrl')" :additionalRatings="$t('reviews.additionalRatings')"
            :commentsCount="$t('sub_header.commentsCount')" :titleComments="$t('sub_header.titleComments')"
            :appSize="$t('sub_header.appSize')" :addDownloadCaption="$t('sub_header.addDownloadCaption')"
            :addDownloadTitle="$t('sub_header.addDownloadTitle')" :whoСhooses="$t('sub_header.whoСhooses')"
            :ageLimitDescription="$t('sub_header.ageLimitDescription')" />

         <div :class="'block__item RTL-end'">
            <BubttonInstallPWA :title="$t('buttons.install')" />
         </div>

         <div class="block__item__inter " v-if="isVideoHeaderShow"></div>

      </div>

      <div class="block__item__inter " v-if="isVideoHeaderShow"></div>

      <div class="block__slider">
         <ImgsSliderMain />
      </div>

      <div :class="'block__item RTL-end'">
         <div class="block__item__blockAbout">
            <BlockAboutMain :title="$t('about.title')" :description="$t('about.description')" />
            <!-- <BlockTimeMain /> -->
         </div>
      </div>

      <div :class="'block__item RTL-end'">
         <BlockInfoBorderArround :itemsStringArray="aboutArroundDataArray" />
         <!-- <BlockInfoBorderArround :itemsStringArray="$t('about_arround')" /> -->
      </div>

      <div :class="'block__item RTL-end'">
         <BlockAboutMain :title="$t('safety.title')" :description="$t('safety.description')" :isEllipsis="0" />
      </div>
      <div style="margin-bottom: -42px;"> </div>

      <div class="block__slider">
         <BlockAboutFullMain />
      </div>

      <div :class="'block__item RTL-end'">
         <BlockAboutMain :title="$t('reviews.title')" :description="$t('reviews.description')" :lastSearchIcon="1"
            :isEllipsis="0" />
      </div>

      <!-- <div :class="'block__item RTL-end'">
         <BlockDevicesBorderArround />
      </div> -->

      <div :class="'block__item RTL-end'">
         <BlockAppRatings :additionalRatings="$t('reviews.additionalRatings')" />
      </div>

      <div :class="'block__item RTL-end'">
         <CommentsDrawer :title="$t('about.title')" :description="$t('about.description')" />
      </div>


   </div>

</template>

<style lang="scss" scoped>
.button_parent_arround {
   display: flex;
   gap: 12px;
}

.button_arround {
   border-color: rgb(218, 220, 224);
   color: var(--data_color_additional_text);
   padding: 8px 14px;
   border-radius: 50px;
   border: 1px solid rgb(218, 220, 224);
   white-space: nowrap;
}

.common_content {
   margin: 0 auto;
   min-height: 56px;
   position: relative;
   width: 100%;
   // width: calc(100% - 48px);
   // background-color: rgba(236, 255, 127, 0.466);
   height: 100%;
}

.block__slider {
   overflow: hidden;
   padding: var(--app_common_padding);
   margin-top: 12px;
}

.block__item {
   align-items: center;
   display: flex;
   overflow: auto;
   overflow-y: scroll;
   scrollbar-width: none;
   -ms-overflow-style: none;

   width: 100%;
   display: flex;
   flex-direction: row;
   justify-content: flex-start;
   align-content: flex-start;
   padding: var(--app_common_x_padding) var(--app_common_y_padding);
   // width: 100%;
   // display: flex;
   // flex-direction: row;
   // justify-content: center;
   // align-content: flex-start;
   // padding: var(--app_common_x_padding) var(--app_common_y_padding);
}

.block__item__blockAbout {
   width: 100%;
}

.block__item__inter {
   height: 16px;
}
</style>
